<template>
	<v-row align="center" justify="center">
		<v-col cols="12" lg="7">
			<v-form @submit.prevent="submit" v-model="valid" ref="form">
				<v-textarea v-model="form.description" :rules="[rules.max]" label="Popis" counter :error-messages="errors.description"></v-textarea>

				<v-btn color="primary" type="submit" block :loading="form.busy">{{ $t('save') }}</v-btn>
			</v-form>
		</v-col>
		<v-snackbar v-model="form.successful" bottom color="success" left :absolute="false">
			{{ $t('messages.success.save') }}
		</v-snackbar>
	</v-row>
</template>

<script>
import Form from 'vForm'
import { mapGetters } from 'vuex'
export default {
	name: 'Description',

	computed: {
		...mapGetters({
			user: 'auth/user'
		})
	},

	data() {
		return {
			form: new Form({
				description: null
			}),
			valid: true,
			showOld: false,
			showNew: false,
			showNewConfirmation: false,
			rules: {
				max: v => (v && v.length <= 255) || 'Max 255 characters'
			},
			errors: {}
		}
	},

	created() {
		this.form.description = this.user.description
	},

	methods: {
		submit() {
			this.valid = this.$refs.form.validate()
			if (this.valid) {
				this.update()
			}
		},
		async update() {
			try {
				await this.form.patch('/barber/profile/description')
				await this.$store.dispatch('auth/fetchUser')
			} catch ({ response }) {
				this.errors = response.data.errors
			}
		}
	}
}
</script>
